// extracted by mini-css-extract-plugin
export default {"label":"UfoFilterLabel_label__hWT26"};